// events.ts
export enum MonitoringEventTypes {
    // CUSTOMERS EVENT
    POS_PAGE_CUSTOMER_CREATED_SUCCESS = "pos_page_customer_create_success",
    POS_PAGE_CUSTOMER_CREATED_FAIL = "pos_page_customer_create_fail",
    POS_PAGE_CUSTOMER_EDIT_SUCCESS = "pos_page_customer_edit_success",
    POS_PAGE_CUSTOMER_EDIT_FAIL = 'pos_page_customer_edit_fail',
    CUSTOMERS_PAGE_CUSTOMER_CREATE_SUCCESS = "customers_page_customer_create_success",
    CUSTOMERS_PAGE_CUSTOMER_CREATED_FAIL = "customers_page_customer_create_fail",
    CUSTOMERS_PAGE_CUSTOMER_BULK_CREATE_SUCCESS = "customers_page_customer_bulk_create_success",
    CUSTOMERS_PAGE_CUSTOMER_BULK_CREATED_FAIL = "customers_page_customer_bulk_create_fail",
    CUSTOMERS_PAGE_CUSTOMER_EDIT_SUCCESS = "customers_page_customer_edit_success",
    CUSTOMERS_PAGE_CUSTOMER_EDIT_FAIL = 'customers_page_customer_edit_fail',

    // Order Events
    ORDER_PAGE_ORDER_CREATE_SUCCESS = "order_page_order_create_success",
    ORDER_PAGE_ORDER_CREATE_FAIL = "order_page_order_create_fail",
    ORDER_PAGE_ORDER_STATUS_UPDATE = "order_page_order_status_update",
    ORDER_PAGE_ORDER_VIEW_DETAIL = "order_page_order_view_detail",
    ORDER_PAGE_ORDER_CANCELLED = "order_page_order_cancelled",

    // PAGE NAVIGATION EVENTS
    NAVIGATION_PAGE_VIEWED = "$pageview", //NATIVE POSTHOG EVENT

    //ROUTES EVENTS
    ROUTE_CREATE_SUCCESS = "route_create_success",
    ROUTE_START_SUCCESS = "route_start_success",

    //ORDER STATUSES
    ORDER_ACCEPTED = 'order_accepted',

    //Accounts
    SIGNED_UP = 'signed_up_new_company',

    //GOOGLE AUTOCOMPLETE
    AUTOCOMPLETE_PLACE_SELECTED = 'autocomplete_place_selected',

    //SCANNER EVENTS
    SCANNER_ORDER_SCANNED_PRESENTED = 'scanner_order_scanned_presented',
    SCANNER_ORDER_FOUND = 'scanner_order_found',
    SCANNER_ORDER_NOT_FOUND = 'scanner_order_not_found',


    //STORE CHANGE EVENTS , TRACKING IF THE USER CHANGED THE STORE FROM THE HEADER OR THE CRUD PAGE DROPDOWN
    STORE_CHANGED_FROM_APP_NAV_HEADER = 'store_changed_from_app_nav_header',
    STORE_CHANGED_FROM_CRUD_PAGE_HEADER = 'store_changed_from_crud_page_header',

    //LOYALTY POINTS EVENTS
    LOYALTY_POINTS_PRESENTED = 'loyalty_points_presented',
    LOYALTY_POINTS_APPLIED = 'loyalty_points_applied',

    //PRODUCT EVENTS
    POS_PAGE_PRODUCT_CREATED_SUCCESS = 'pos_page_product_created_success',
    POS_PAGE_PRODUCT_CREATED_FAIL = 'pos_page_product_created_fail',

    //MERCADO PAGO EVENTS
    MERCADO_PAGO_RETRY_ATTEMPT = 'mercado_pago_retry_attempt',
    MERCADO_PAGO_ATTEMPT_CREATED_SUCCESS = 'mercado_pago_attempt_created_success',
    MERCADO_PAGO_ATTEMPT_CREATED_FAIL = 'mercado_pago_attempt_created_fail',
    MERCADO_PAGO_SHEET_VIEWED = 'mercado_pago_sheet_viewed',

    // EVIDENCE EVENTS
    ORDER_EVIDENCE_UPLOAD_SUCCESS = 'order_evidence_upload_success',
    ORDER_EVIDENCE_UPLOAD_FAIL = 'order_evidence_upload_fail',

    // LINE STATUS EVENTS
    ORDER_LINE_STATUS_UPDATE_SUCCESS = 'order_line_status_update_success',
    ORDER_LINE_STATUS_UPDATE_FAIL = 'order_line_status_update_fail',

    // CFDI EVENTS
    CFDI_INVOICE_CREATE_SUCCESS = 'cfdi_invoice_create_success',
    CFDI_INVOICE_CREATE_FAIL = 'cfdi_invoice_create_fail',
    CFDI_INVOICE_CANCEL_SUCCESS = 'cfdi_invoice_cancel_success',
    CFDI_INVOICE_CANCEL_FAIL = 'cfdi_invoice_cancel_fail',

    // Add more events as needed
}
